import React, { useState } from "react";

function GroupedLogs({ logs, entityType }) {
  const [filters, setFilters] = useState({
    entityId: "",
    status: "",
    result: "",
    message: "",
    severity: "",
    origin: "",
    timestamp: "",
  });

  const [corrFilter, setCorrFilter] = useState("");

  const handleChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  const filtered = logs.filter((log) => {
    return (
      (log.correlationId || "").toLowerCase().includes(corrFilter.toLowerCase()) &&
      entityType === "ARTICLE"
    ? (log.articleId || log.bomId || "")
    : entityType === "SUPPLIER"
    ? (log.supplierNumber || log.bomId || "")
    : (log.bomId || "")
).toLowerCase().includes(filters.entityId.toLowerCase()) &&
      (log.status || "").toLowerCase().includes(filters.status.toLowerCase()) &&
      (log.result || "").toLowerCase().includes(filters.result.toLowerCase()) &&
      (log.message || "").toLowerCase().includes(filters.message.toLowerCase()) &&
      (log.severity || "").toLowerCase().includes(filters.severity.toLowerCase()) &&
      (log.origin || "").toLowerCase().includes(filters.origin.toLowerCase()) &&
      (log.timestamp || "").toLowerCase().includes(filters.timestamp.toLowerCase())
    
  });  

  const groups = {};
  filtered.forEach((log) => {
    if (!groups[log.correlationId]) groups[log.correlationId] = [];
    groups[log.correlationId].push(log);
  });

  Object.keys(groups).forEach((id) => {
    groups[id].sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
  });

  return (
    <div>
      {Object.keys(groups).map((id) => (
        <div key={id} style={{ marginBottom: "30px" }}>
          
          {/* GROUP TITLE */}
          <div className="correlation-title">
            Correlation ID: {id}
          </div>

          <table className="log-table">
            <thead>
              {/* COLUMN LABELS */}
              <tr>
                <th>
  {entityType === "ARTICLE"
    ? "Article ID"
    : entityType === "SUPPLIER"
    ? "Supplier ID"
    : "BOM ID"}
</th>
                <th>Status</th>
                <th>Result</th>
                <th>Message</th>
                <th>Severity</th>
                <th>Origin</th>
                <th>Timestamp</th>
              </tr>

              {/* FILTER ROW — SAME LOOK AS RAW LOG TABLE */}
              <tr className="filter-row">
                <th>
                  <input
                    name="bomId"
                    placeholder="Filter..."
                    value={filters.bomId}
                    onChange={handleChange}
                  />
                </th>
                <th>
                  <input
                    name="status"
                    placeholder="Filter..."
                    value={filters.status}
                    onChange={handleChange}
                  />
                </th>
                <th>
                  <input
                    name="result"
                    placeholder="Filter..."
                    value={filters.result}
                    onChange={handleChange}
                  />
                </th>
                <th>
                  <input
                    name="message"
                    placeholder="Filter..."
                    value={filters.message}
                    onChange={handleChange}
                  />
                </th>
                <th>
                  <input
                    name="severity"
                    placeholder="Filter..."
                    value={filters.severity}
                    onChange={handleChange}
                  />
                </th>
                <th>
                  <input
                    name="origin"
                    placeholder="Filter..."
                    value={filters.origin}
                    onChange={handleChange}
                  />
                </th>
                <th>
                  <input
                    name="timestamp"
                    placeholder="Filter..."
                    value={filters.timestamp}
                    onChange={handleChange}
                  />
                </th>
              </tr>
            </thead>

            <tbody>
              {groups[id].map((log, idx) => (
                <tr key={idx} className={`sev-${log.severity}`}>
                  <td>
  {entityType === "ARTICLE"
    ? (log.articleId || log.bomId)
    : entityType === "SUPPLIER"
    ? (log.supplierNumber || log.bomId)
    : log.bomId}
</td>
                  <td>{log.status}</td>
                  <td>
                    <span className={`status-badge status-${log.result}`}>
                      {log.result}
                    </span>
                  </td>
                  <td>{log.message}</td>
                  <td>{log.severity}</td>
                  <td>{log.origin}</td>
                  <td>{log.timestamp}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}

export default GroupedLogs;
